import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { StudentsForImpactService } from '../../../shared/services/students-for-impact.service';
import { UserService } from '../../../shared/services';
import { ToastyService } from 'ng2-toasty';
import { environment } from '../../../../environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTable, DataTableTranslations, DataTableParams } from 'angular-datatables-all-versions';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { fromEvent } from 'rxjs/observable/fromEvent';

import { StudentsForImpactListDataSource } from './students-for-impact-list.datasource';
import { IPaginationUsersImpact, IUsersImpact } from './ipagination-impact.model';
import { StudentsForImpactValidateComponent } from '../students-for-impact-validate/students-for-impact-validate.component';
import { User } from 'app/shared/models/user.model';
import { IUser } from 'app/shared/models/ipagination.model';

@Component({
  selector: 'app-students-for-impact-list',
  templateUrl: './students-for-impact-list.component.html',
  styleUrls: ['./students-for-impact-list.component.css']
})
export class StudentsForImpactListComponent implements OnInit {

  @ViewChild('search_input', { static: true }) searchInputRef: ElementRef;
  @ViewChild('search_btn', { static: true }) searchBtnRef: ElementRef;
  @ViewChild(DataTable, { static: true }) studentsForImpactTable: DataTable;

  public site_url: string;
  users: IUsersImpact[] = [];
  userCount = 0;
  offset = 0;
  limits = [5, 10, 25, 50, 100];
  now = new Date();
  routeParams: DataTableParams;

  dataSource: StudentsForImpactListDataSource;

  translations = <DataTableTranslations>{
    indexColumn: 'Num.',
    expandColumn: 'Informations',
    selectColumn: 'Sélectionner',
    paginationLimit: 'Max.',
    paginationText: 'Résultats: {from} - {to} / {total}',
    paginationTotalPages: '/'
  }

  constructor(private router: Router, private route: ActivatedRoute, private toastyService: ToastyService,
    private modalService: NgbModal, private studentsForImpactService: StudentsForImpactService, private service: UserService, private changeDetector: ChangeDetectorRef) {
    this.dataSource = new StudentsForImpactListDataSource(studentsForImpactService);
    this.site_url = environment.base_url;
  }

  ngOnInit() {
    this.dataSource.load();
    this.dataSource.pagination.subscribe(
      (data: IPaginationUsersImpact) => {
        if (data && data.hasOwnProperty('pagination')) {
          this.userCount = data.pagination.total;
          this.users = data.data.map(item => {
            //item['category_name'] = item.category.name;
            return item;
          });
        }
      });
  }

  ngAfterViewInit(): void {
    fromEvent(this.searchBtnRef.nativeElement, 'click').pipe(debounceTime(100), distinctUntilChanged(),
      tap(() => {
        this.changeDetector.detectChanges();
        this.studentsForImpactTable.offset = 1;

        this.loadUsersPage();
      })).subscribe(() => {
        this.dataSource.pagination.subscribe(
          () => {
            this.changeDetector.detectChanges();
          });
      });
  }

  reload(_params: DataTableParams) {
    this.routeParams = _params;
    this.loadUsersPage();
  }

  cellColor(car) {
    return 'rgb(255, 255,' + (155 + Math.floor(100 - ((car.rating - 8.7) / 1.3) * 100)) + ')';
  }

  private loadUsersPage() {
    if (!this.routeParams) {
      this.routeParams = { offset: 0, limit: this.studentsForImpactTable.limit || 50 } as DataTableParams;
    }
    const offset = this.routeParams.offset / this.routeParams.limit;
    this.dataSource.load(this.searchInputRef.nativeElement.value, offset + 1, this.routeParams.limit, null);
  }

  onValidateDocuments(user: IUsersImpact) {
    const modalRef = this.modalService.open(StudentsForImpactValidateComponent, { size: 'lg' });
    modalRef.componentInstance.user = user;

    modalRef.result.then((result) => {
      if ('validation-success' === result) {
        this.loadUsersPage();

        this.toastyService.success({
          title: 'Succès',
          msg: 'Documents validés avec succès',
          showClose: true,
          timeout: 5000,
          theme: 'bootstrap',
        });
      }
    }, err => console.log('error', err));
  }

  isStillValid(dateString: string): number {
    const today = new Date();
    const alertDate = new Date(today.setDate(today.getDate() - 10));
    const date = new Date(dateString);
    if (date >= today) {
      return 1;
    } else if (date > alertDate) {
      return 2;
    } else {
      return 0;
    }
  }

  isDocumentToValidate(currentUser: IUsersImpact): boolean {
    if (currentUser.degree && currentUser.degree.status === 1) {
      return true;
    }
    if (currentUser.self_employed && currentUser.self_employed.status === 1) {
      return true;
    }
    return false;
  }

  // Check if document is PDF or image
  isPdf(url: string): boolean {
    return url && url.toLowerCase().includes('.pdf');
  }

  onBanUser(user: IUser) {
    this.service.enableOrDesableUser(Object.assign(new User(), user)).subscribe(
      data => {
        this.loadUsersPage();
        // notify user
        const verb = data.is_active ? 'activ&eacute;e' : 'desactiv&eacute;e';
        this.toastyService.success({
          title: 'Success',
          msg: 'Utilisateur ' + verb,
          showClose: true,
          timeout: 5000,
          theme: 'bootstrap',
        });
      },
      () => this.toastyService.error({
        title: 'Attention',
        msg: 'Une erreur s\'est produite, reessayer plus tard',
        showClose: true,
        timeout: 5000,
        theme: 'bootstrap',
      }));
    }

  switchActivationCertificationImpact(user) {
    this.studentsForImpactService.onActivateOrDeactivateCertificationImpact(user.id).subscribe(
      data => {
        this.loadUsersPage();

        // notify user
        const verb = data.is_impact ? 'est certifié' : "n'est plus certifié";
        this.toastyService.success({
          title: 'Success',
          msg: 'Students for impact ' + verb,
          showClose: true,
          timeout: 5000,
          theme: 'bootstrap',
        });
      },
      () => this.toastyService.error({
        title: 'Attention',
        msg: 'Une erreur s\'est produite, reessayer plus tard',
        showClose: true,
        timeout: 5000,
        theme: 'bootstrap',
      })
    );
  }

  onExportData() {
    this.studentsForImpactService.exportImpactUser().subscribe(
      (result) => {
        if (result.success) {
          this.toastyService.success({
            title: 'Téléchargement réussi',
            msg: 'Le fichier a été téléchargé avec succès',
            theme: 'bootstrap',
            showClose: true,
            timeout: 5000
          });
        } else {
          this.toastyService.error({
            title: 'Erreur',
            msg: result.error || 'Erreur lors du téléchargement du fichier',
            theme: 'bootstrap',
            showClose: true,
            timeout: 5000
          });
        }
      },
      (error) => {
        this.toastyService.error({
          title: 'Erreur',
          msg: 'Erreur lors du téléchargement du fichier',
          theme: 'bootstrap',
          showClose: true,
          timeout: 5000
        });
      }
    );
  }
}